import { render } from "./icon-email.vue?vue&type=template&id=a387266a"
import script from "./icon-email.vue?vue&type=script&lang=js"
export * from "./icon-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/icons/icon-email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a387266a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a387266a', __exports__)) {
    api.reload('a387266a', __exports__)
  }
  
  module.hot.accept("./icon-email.vue?vue&type=template&id=a387266a", () => {
    api.rerender('a387266a', render)
  })

}


export default __exports__